export const LOCKED_TRANSACTION_CLAIM_STATUSES = [
  "Extracted",
  "For Processing",
  "For RTP",
  "from Extracted to cancelled",
  "from For Processing to cancelled",
  "from from Extracted to cancelled to cancelled",
  "from from For Processing to cancelled to cancelled",
  "from from from Extracted to cancelled to cancelled",
  "from from Processed to cancelled to cancelled",
  "from Paid to cancelled",
  "from Processed to cancelled",
  "Paid",
  "Processed",
];

export const LOCKED_TRANSACTION_FLAG_CODES = [
  "02",
  "03",
  "04",
  "06",
  "07",
  "10",
  "11",
  "99",
];

export const LOCKED_TRANSACTION_CANCEL_FLAG_CODES = ["04"];

const FLAG_LABELS = {
  "01": "Approved TRN",
  "02": "Approved TRN with LOA",
  "03": "Discharged",
  "04": "Cancelled",
  "06": "Processed Reimbursement",
  "07": "Invalid Reimbursement",
  "10": "Reimbursement",
  "11": "Endorsed Reimbursement",
  "99": "Rejected",
};

const normalizeStatus = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

const LOCKED_CLAIM_STATUS_SET = new Set(
  LOCKED_TRANSACTION_CLAIM_STATUSES.map(normalizeStatus)
);

export const getTransactionEditLockReason = (transaction = {}) => {
  const transFlagCode = String(transaction.trans_flag_status || "").trim();
  if (LOCKED_TRANSACTION_FLAG_CODES.includes(transFlagCode)) {
    const label =
      transaction.trans_flag_desc ||
      transaction.trn_status ||
      FLAG_LABELS[transFlagCode] ||
      transFlagCode;

    return `Editing is disabled because TRN status is ${label}.`;
  }

  const claimStatusRaw = String(transaction.claim_status || "").trim();
  if (claimStatusRaw && LOCKED_CLAIM_STATUS_SET.has(normalizeStatus(claimStatusRaw))) {
    return `Continue Generate LOA is disabled because claim status is ${claimStatusRaw}.`;
  }

  return "";
};

export const getTransactionCancelLockReason = (transaction = {}) => {
  const transFlagCode = String(transaction.trans_flag_status || "").trim();
  if (LOCKED_TRANSACTION_CANCEL_FLAG_CODES.includes(transFlagCode)) {
    const label =
      transaction.trans_flag_desc ||
      transaction.trn_status ||
      FLAG_LABELS[transFlagCode] ||
      transFlagCode;

    return `Cancel is disabled because TRN status is ${label}.`;
  }

  const batchNo = String(transaction.batch_no ?? "").trim();
  if (batchNo) {
    return `Cancel is disabled because this transaction already has Batch No. ${batchNo}.`;
  }

  const claimStatusRaw = String(transaction.claim_status || "").trim();
  if (claimStatusRaw && LOCKED_CLAIM_STATUS_SET.has(normalizeStatus(claimStatusRaw))) {
    return `Cancel is disabled because claim status is ${claimStatusRaw}.`;
  }

  return "";
};

export const isTransactionEditLocked = (transaction = {}) =>
  getTransactionEditLockReason(transaction) !== "";
